import { useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import i18next from "src/i18n/config";

import { Box, Typography } from "@mui/material";
import { withMetaDescription } from "@navigation/utils/withMetaDescription";
import ApmLink from "@shared/ApmLink";

import { AuthFlowContainer } from "../AuthFlowContainer";

import RegisterForm from "./RegisterForm";
import { useStyles } from "./RegisterPage.style";

const RegisterPage = () => {
    const { classes } = useStyles();
    const { t } = useTranslation(["pages"]);
    const [isRegistrationComplete, setIsRegistrationComplete] = useState(false);

    return (
        <AuthFlowContainer>
            <Box className={classes.formSection}>
                <RegisterForm onRegistrationComplete={setIsRegistrationComplete} />
            </Box>

            {!isRegistrationComplete && (
                <Box className={classes.footer}>
                    <Typography className={classes.footerText}>
                        <Trans
                            ns="pages"
                            i18nKey="registerPage.alreadyHaveAccountWithLink"
                            components={{
                                Link: <ApmLink role="link" parent="Registration page" title="Sign in" to="/login" />,
                            }}
                        />
                    </Typography>

                    <Box className={classes.infoSection}>
                        <Box className={classes.stepsList}>
                            <Box className={classes.stepRow}>
                                <Box className={classes.stepCircle}>
                                    <Typography className={classes.circleText}>1</Typography>
                                </Box>
                                <Typography className={classes.stepText}>{t("pages:registerPage.getStarted.step1")}</Typography>
                            </Box>
                            <Box className={classes.stepRow}>
                                <Box className={classes.stepCircle}>
                                    <Typography className={classes.circleText}>2</Typography>
                                </Box>
                                <Typography className={classes.stepText}>{t("pages:registerPage.getStarted.step2")}</Typography>
                            </Box>
                            <Box className={classes.stepRow}>
                                <Box className={classes.stepCircle}>
                                    <Typography className={classes.circleText}>3</Typography>
                                </Box>
                                <Typography className={classes.stepText}>{t("pages:registerPage.getStarted.step3")}</Typography>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            )}
        </AuthFlowContainer>
    );
};

export default withMetaDescription(RegisterPage, {
    title: i18next.t("pages:registerPage.metaTitle"),
    description: i18next.t("pages:registerPage.metaDescription"),
});
